import axiosAuth from "../../axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  taskId: string;
  attachmentId: string;
}

const mutateDeleteTaskAttachment = async ({projectId, taskId, attachmentId}: mutateProps) => {
  return await axiosAuth.delete(`${PROJECT_API}/${projectId}/tasks/${taskId}/attachments/${attachmentId}`);
};

const useDeleteTaskAttachmentMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateDeleteTaskAttachment,
    ...queryParams,
  });

export default useDeleteTaskAttachmentMutation;
